export default {
  get dispatcher() {
    return window.vp.common.dispatcher;
  },
};
